import { render, staticRenderFns } from "./gameOver.vue?vue&type=template&id=1bf8e1ac&scoped=true&"
import script from "./gameOver.vue?vue&type=script&lang=js&"
export * from "./gameOver.vue?vue&type=script&lang=js&"
import style0 from "./gameOver.vue?vue&type=style&index=0&id=1bf8e1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8e1ac",
  null
  
)

export default component.exports